/** @format */

import { Enviroment } from '../../_config/constants/enviroment-v2.constant';
import { AxiosAdapter } from '../../_config/v2/adapters/axios/axios.adapter';
import { Http } from '../../v2-config/adapters/axios/axios.protocols';

export class Service2 {
	

	async trackOrder(item){
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/tracking-order/by-purchase/${item}?dispatch_notification=true`,
	})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}		
}
